export default function formatSecondsToHours(seconds) {
  const horas = Math.floor(seconds / 3600);
  const minutosRestantes = Math.floor((seconds % 3600) / 60);
  return `${horas}h ${minutosRestantes}min`;
}

export const getTimeDiffInSeconds = (date1, date2) => {
  return Math.abs(Math.floor((new Date(date2) - new Date(date1)) / 1000));
};
